require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-jennersdorf-neuhaus-am-klausenbach.json") })
        }
      }, "path---betreuungseinrichtungen-jennersdorf-neuhaus-am-klausenbach");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-jennersdorf-neuhaus-am-klausenbach!./.cache/json/betreuungseinrichtungen-jennersdorf-neuhaus-am-klausenbach.json
// module id = 918
// module chunks = 231608221292675